<script>
  import { colors } from "../utils/colors.ts";
  import Switcher from "./Switcher.svelte";
  export let oldInput;
  export let unit;
  export let isShowTree;
  export let value = "";
  export let tree = "";
  export let searchField;
  export let targetId;
  function toggle() {
    if (expanded === null) {
      return;
    }
    expanded = !expanded;
  }
  function isOpen(unt = unit) {
    if (value.length < 4) {
      return false;
    } else {
      return true;
    }
  }
  function isShow() {
    let result;
    if (value.length < 4) {
      result = true;
    } else if (
      unit.unit.name
        .toLowerCase()
        .trim()
        .indexOf(value.toLowerCase().trim()) !== -1 ||
      isOpen()
    ) {
      result = true;
    } else {
      result = false;
    }
    return result;
  }
  function isShowChildren(unt = unit) {
    if (!unit || !unit.children || unit.children.length === 0) {
      return null;
    }
    for (const key of Object.keys(unt.children)) {
      if (
        unt.children[key].unit.name
          .toLowerCase()
          .trim()
          .indexOf(value.toLowerCase().trim()) !== -1
      ) {
        return true;
      }
      const res = isShowChildren(unt.children[key]);
      if (res) {
        return true;
      }
    }
    return false;
  }

  let expanded = isOpen();
  let val;
</script>

<li
  style="display: {isShow()
    ? 'block'
    : 'none'}; --hoverGreen: {colors.veryLightGreen}"
>
  <Switcher isActive={!isShowChildren() ? null : expanded} onСlick={toggle} />
  <span
    on:click={(e) => {
      targetId.set(unit.unit.id.toString());
      oldInput.value = unit.unit.id.toString();
      searchField.value = unit.unit.name;
      searchField.dispatchEvent(new Event("keyup"));
      isShowTree = false;
    }}
  >
    {unit ? unit.unit.name : ""}
  </span>
  {#if expanded}
    <nav style="--green:{colors.lightGreen}">
      {#if unit}
        {#each Object.keys(unit.children) as childId (childId)}
          <svelte:self
            bind:isShowTree
            bind:searchField
            bind:tree
            bind:targetId
            {oldInput}
            {value}
            unit={unit.children[childId]}
          />
        {/each}
      {/if}
    </nav>
  {/if}
</li>

<style>
  li {
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
  }
  span {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: calc(100% - 10px);
    margin-right: 15px;
  }
  span:hover {
    background-color: var(--hoverGreen);
  }
  nav {
    padding-left: 0.5em;
    margin-left: 0.19em;
    border-left: 0.5px solid var(--green);
  }
</style>
